import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../services/auth.service';
import { User } from '../services/user.model';

@Component({
  selector: 'pm-progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.sass']
})
export class ProgressbarComponent implements OnInit {
  @Input() countMinutes: number;
  @Input() countSeconds: number;
  @Input() progressCount: number;
  
  constructor(public activeModal: NgbActiveModal, private authService: AuthService) {
  }

  ngOnInit() {
    console.log('ProgressbarComponent Inicializado...');
  }

  continue() {
    this.activeModal.close(null);
  }

  logout() {
    console.log('ProgressbarComponent: logout: Entrando...');

    const tmpUserData = localStorage.getItem('loginUserData');
    const loginUserData = (tmpUserData) ? JSON.parse(tmpUserData) as User : null;
    console.log('ProgressbarComponent: logout: loginUserData: ', JSON.stringify(loginUserData));
    
    this.authService.loginUser$(loginUserData);
    
    this.activeModal.close('logout');
  }

}
